import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// catalogs ////////////////////
const catalogsUrl = "admin/catalogs";

// get all catalogs
export const getAllCatalogsDataRequest = (values) =>
  client.get(`
${catalogsUrl}?
skip=${values.skip ?? 0}&limit=${values.limit ?? 10}
  ${values.search ? "&search=" + convertNum(values.search) : ""}
`);

// get catalog by id
export const getCatalogByIdRequest = (values) =>
  client.get(`${catalogsUrl}/${values.id}`);
